__turbopack_context__.v({
  "container": "Overview-module__0vH8-G__container",
  "lead": "Overview-module__0vH8-G__lead",
});
